// extracted by mini-css-extract-plugin
module.exports = {"TotoDetailsContainer":"TotoDetails_TotoDetailsContainer__27SRW","title":"TotoDetails_title__3_qYA","text":"TotoDetails_text__2Donj"};